import axios from 'axios' 

function formatArenaPlacement(number) {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = number % 100;
    return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}

function formatSkillOrderPositions(number) {
    number = number + 1
    const suffixes = ["th", "st", "nd", "rd"];
    const v = number % 100;
    return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}

function checkIfChampionIsKaynTransformation(championName, championTransform) {
    if (championName === "Kayn") {
        if (championTransform === 1) {
            return "Rhaast";
        } else if (championTransform === 2) {
            return "ShadowAssassin";
        }
    }
    return championName; // Return the original name if no conditions are met (which can also mean game ended with untransformed Kayn)
}

const CHAMPION_DISPLAY_NAME_OVERRIDES = {
    AurelionSol: 'Aurelion Sol',
    Belveth: "Bel'Veth",
    DrMundo: 'Dr. Mundo',
    FiddleSticks: 'Fiddlesticks',
    JarvanIV: 'Jarvan IV',
    KaiSa: "Kai'Sa",
    Khazix: "Kha'Zix",
    KogMaw: "Kog'Maw",
    LeeSin: 'Lee Sin',
    MasterYi: 'Master Yi',
    MissFortune: 'Miss Fortune',
    MonkeyKing: 'Wukong',
    Nunu: 'Nunu & Willump',
    RekSai: "Rek'Sai",
    ShadowAssassin: 'Shadow Assassin',
    XinZhao: 'Xin Zhao',
}

function formatChampionDisplayName(championName) {
    const normalizedName = String(championName || '').trim()
    if (!normalizedName) return ''

    return CHAMPION_DISPLAY_NAME_OVERRIDES[normalizedName]
        || normalizedName.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ').trim()
}

function normalizeContentPath(path) {
    const normalizedPath = path.replace(
        /(^|\/)champion_icons\/FiddleSticks(\.png$)/,
        '$1champion_icons/Fiddlesticks$2'
    );

    const simplePrefixes = {
        champion_icons: 'icons/champions',
        item_icons: 'icons/items',
        profile_icons: 'icons/profile',
        summoner_spell_icons: 'icons/summoner-spells',
        champion_spell_icons: 'icons/champion-spells',
        augment_icons: 'icons/augments',
    };

    for (const [sourcePrefix, contentPrefix] of Object.entries(simplePrefixes)) {
        if (normalizedPath.startsWith(`${sourcePrefix}/`)) {
            return `${contentPrefix}/${normalizedPath.slice(sourcePrefix.length + 1)}`;
        }
    }

    const treeIcon = normalizedPath.match(/^major_and_minor_rune_icons\/trees\/(\d+)\.png$/);
    if (treeIcon) {
        return `icons/runes/trees/${treeIcon[1]}.png`;
    }

    const treeRune = normalizedPath.match(/^major_and_minor_rune_icons\/trees\/(\d+)\/slot_(\d+)\/(.+)$/);
    if (treeRune) {
        const [, tree, slot, fileName] = treeRune;
        const group = slot === '1' ? 'major' : 'minor';
        return `icons/runes/${group}/${tree}/slot_${slot}/${fileName}`;
    }

    const statShard = normalizedPath.match(/^major_and_minor_rune_icons\/stat_mods\/slot_(\d+)\/(.+)$/);
    if (statShard) {
        return `icons/runes/stat-shards/slot_${statShard[1]}/${statShard[2]}`;
    }

    return normalizedPath;
}

const PROD_HOSTS = new Set(["winrates.gg", "www.winrates.gg"]);

function webOrigin(hostname = window.location.hostname) {
    if (hostname.startsWith("staging.")) {
        return "https://staging.winrates.gg";
    }

    if (PROD_HOSTS.has(hostname)) {
        return "https://winrates.gg";
    }

    // Local development uses the staging distribution for shared content.
    return "https://staging.winrates.gg";
}

function originFor(service, hostname = window.location.hostname) {
    if (service === "content") {
        return webOrigin(hostname);
    }

    // --- STAGING ---
    if (hostname.startsWith("staging.")) {
        return `https://${service}.${hostname}`;
    }

    // --- PRODUCTION ---
    if (PROD_HOSTS.has(hostname)) {
        return `https://${service}.winrates.gg`;
    }

    // --- LOCAL DEV ---
    if (service === "api") {
        return `http://${hostname}:8000`;
    }

    return webOrigin(hostname);
}

const axiosForAPI = axios.create({
    baseURL: originFor("api"),
});

const axiosForContent = axios.create({
    baseURL: webOrigin(),
});


function assetUrl(path) {
    const normalizedPath = normalizeContentPath(path.startsWith('/') ? path.slice(1) : path);
    return new URL(normalizedPath, `${webOrigin()}/`).toString();
}

export { assetUrl, axiosForContent, axiosForAPI, formatArenaPlacement, formatSkillOrderPositions, checkIfChampionIsKaynTransformation, formatChampionDisplayName, webOrigin, originFor }
